import { render, staticRenderFns } from "./couponSelect.vue?vue&type=template&id=5b5a4bf2&scoped=true"
import script from "./couponSelect.vue?vue&type=script&lang=js"
export * from "./couponSelect.vue?vue&type=script&lang=js"
import style0 from "./couponSelect.vue?vue&type=style&index=0&id=5b5a4bf2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b5a4bf2",
  null
  
)

export default component.exports